import axios from "axios";
const apiURL = process.env.REACT_APP_API_URL;

const BearerToken = () =>
  localStorage.getItem("jwt")
    ? JSON.parse(localStorage.getItem("jwt")).token
    : false;
const Headers = () => {
  return {
    headers: {
      token: `Bearer ${BearerToken()}`,
    },
  };
};
export const getAllProduct = async () => {
  try {
    let res = await axios.get(`${apiURL}/api/product/all-product`, Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const createPorductImage = async ({ pImage }) => {
  /* Most important part for uploading multiple image  */
  let formData = new FormData();
  for (const file of pImage) {
    formData.append("pImage", file);
  }
  /* Most important part for uploading multiple image  */
};

export const createProduct = async ({
  pName,
  pDescription,
  pImage,
  pStatus,
  pCategory,
  pQuantity,
  pPrice,
  pOffer,
  personId
}) => {
  /* Most important part for uploading multiple image  */
  let formData = new FormData();
  for (const file of pImage) {
    formData.append("pImage", file);
  }
  /* Most important part for uploading multiple image  */
  formData.append("pName", pName);
  formData.append("pDescription", pDescription);
  formData.append("pStatus", pStatus);
  formData.append("pCategory", pCategory);
  formData.append("pQuantity", pQuantity);
  formData.append("pPrice", pPrice);
  formData.append("pOffer", pOffer);
  formData.append("personId", personId);

  try {
    let res = await axios.post(`${apiURL}/api/product/add-product`, formData,Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const editProduct = async (product) => {
  console.log(product);
  /* Most important part for updating multiple image  */
  let formData = new FormData();
  // if (product.pEditImages) {
  //   for (const file of product.pEditImages) {
  //     formData.append("pEditImages", file);
  //   }
  // }
  /* Most important part for updating multiple image  */
  formData.append("pId", product.pId);
  formData.append("pName", product.pName);
  formData.append("pDescription", product.pDescription);
  formData.append("pStatus", product.pStatus);
  formData.append("pCategory", product.pCategory._id);
  formData.append("pQuantity", product.pQuantity);
  formData.append("pPrice", product.pPrice);
  formData.append("pOffer", product.pOffer);
  formData.append("pImages", product.pImages);

  // try {
  //   let res = await axios.post(`${apiURL}/api/product/edit-product`, formData);
  //   return res.data;
  // } catch (error) {
  //   console.log(error);
  // }
};

export const deleteProduct = async (pId) => {
  try {
    let res = await axios.post(`${apiURL}/api/product/delete-product`, { pId });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const productByCategory = async (catId) => {
  try {
    let res = await axios.post(`${apiURL}/api/product/product-by-category`, {
      catId,
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const productByPrice = async (price) => {
  try {
    let res = await axios.post(`${apiURL}/api/product/product-by-price`, {
      price,
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const productByUser = async () => {
  let uId = JSON.parse(localStorage.getItem("jwt")).user._id;
  try {
    let res = await axios.post(`${apiURL}/api/product/product-by-user`, {uId:uId});
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const uploadImage = async (image) => {
  let imageIds, personId;
  const bodyFormData = new FormData();
  for (let i = 0; i < image.length; i++) {
    bodyFormData.append('images', image[i]);

  }
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
      'token': `Bearer ${BearerToken()}`,
    }
  }
  console.log(bodyFormData);
  const url = `${apiURL}/api/photo/add-photo`;
  await axios.post(url, bodyFormData, config)
    .then(async (response) => {
      imageIds = await response.data['Files Object Id'].split(',').slice(0, -1);
      personId = await response.data["Person Id"];
      console.log(imageIds);
    }).catch((e) => {
      console.log(e.message);
    })
  return { imageIds, personId };
}